// Libs
import { ErrorMessage, Field } from "formik";
// UI-Components
import { Label } from "../../UI-Components/Label";
import { Input } from "../../UI-Components/Input";

export default function PayerForm({
  isDisabled = false,
}: {
  isDisabled: boolean;
}) {
  return (
    <div className="grid gap-x-4">
      <div tabIndex={0} style={{ height: 0, width: 0, opacity: 0 }} />
      <div className="my-1">
        <Label
          className="block text-primary text-xs my-2 font-semibold"
          htmlFor="uniqueId"
        >
          Unique ID
        </Label>
        <Field
          as={Input}
          disabled={isDisabled}
          className="w-full py-2 border-primary text-title outline-none rounded transition bg-white"
          type="text"
          id="uniqueId"
          name="uniqueId"
          // required
          placeholder="Enter Unique ID"
        />
        <ErrorMessage
          name="uniqueId"
          component="p"
          className="text-red-500 text-sm"
        />
      </div>
      <div className="my-1">
        <Label
          className="block text-primary text-xs my-2 font-semibold"
          htmlFor="name"
        >
          Name
        </Label>
        <Field
          as={Input}
          disabled={isDisabled}
          className="w-full py-2 border-primary text-title outline-none rounded transition bg-white"
          type="text"
          id="name"
          name="name"
          // required
          placeholder="Enter Name"
        />
        <ErrorMessage
          name="name"
          component="p"
          className="text-red-500 text-sm"
        />
      </div>
      <div className="my-1">
        <Label
          className="block text-primary text-xs my-2 font-semibold"
          htmlFor="address"
        >
          Address
        </Label>
        <Field
          as={Input}
          disabled={isDisabled}
          className="w-full py-2 border-primary text-title outline-none rounded transition bg-white"
          type="text"
          id="address"
          name="address"
          // required
          placeholder="Enter Address"
        />
        <ErrorMessage
          name="address"
          component="p"
          className="text-red-500 text-sm"
        />
      </div>
      <div className="my-1">
        <Label
          className="block text-primary text-xs my-2 font-semibold"
          htmlFor="state"
        >
          State
        </Label>
        <Field
          as={Input}
          disabled={isDisabled}
          className="w-full py-2 border-primary text-title outline-none rounded transition bg-white"
          type="text"
          id="state"
          name="state"
          // required
          placeholder="Enter State"
        />
        <ErrorMessage
          name="state"
          component="p"
          className="text-red-500 text-sm"
        />
      </div>
      <div className="my-1">
        <Label
          className="block text-primary text-xs my-2 font-semibold"
          htmlFor="phoneNumber"
        >
          Phone Number
        </Label>
        <Field
          as={Input}
          disabled={isDisabled}
          className="w-full py-2 border-primary text-title outline-none rounded transition bg-white"
          type="text"
          id="phoneNumber"
          name="phoneNumber"
          // required
          placeholder="Enter Phone Number"
        />
        <ErrorMessage
          name="phoneNumber"
          component="p"
          className="text-red-500 text-sm"
        />
      </div>
    </div>
  );
}
